<template>
<section class="container">
  <!--  v-if="showPage" -->
  <template v-if="showPage">
    <!-- 优惠券 -->
    <section class="coupon_box">
      <coupon-item :item="parkCouponHeader" :size="size" come="getParkingCoupon"></coupon-item>
    </section>
  <!-- 车牌号 -->
  <section class="card_box">
    <section class="title_box">
      <p class="title">输入车牌号领取停车券</p>
    </section>
    <div class="cardBox" @click="showKeyboard = true">
      <span :class="['card_item',(licenseNumber.length == item-1 && showKeyboard)&&common.theme==2?'curS':'',(licenseNumber.length == item-1 && showKeyboard)&&common.theme==1?'curS_2':'']" v-for="item in 8" :key="item">
        {{licenseNumber[item-1]}}
        <img v-if="item==8" src="../../assets/images/xny.png" />
      </span>
    </div>
  </section>
  <!-- 按钮 -->
  <section class="button btn_box">
    <p :class="['search_btn','btn_default',common.theme==1?'search_btn_2':'']" @click="getBtnClick">立即领取</p>
  </section>
  </template>
    <mt-popup v-model="showKeyboard" position="bottom" :modal="false">
      <key-board :keyBoardType="keyBoardType" :numClick="numClick" :textClick="textClick" @hideModal="showKeyboard = false" @inputchange="inputchange"></key-board>
    </mt-popup>
</section>
</template>
<script>
import {mapState} from 'vuex'
import {freeCall} from '../../utils/api'
import util from '../../utils/util'
import CouponItem from './components/couponItemT'
import keyBoard from '../parkingService/components/keyboard';
import storage from '../../utils/storage'
export default {
  name: 'getParkingCoupon',
  props: {

  },
  components: {
    CouponItem,
    keyBoard
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  data() {
    return {
      parkCouponHeader:{},
      showPage:false,
      size:1,
      licenseNumber:[],
      showKeyboard: false, // 是否显示键盘
      keyBoardType: 1, // 键盘类型
      numClick: 2, // 数字是否可点 2:不可点
      textClick: 2, // 文字是否可点2:不可点
    }
  },
  created(){
    this.sceneParkCoupon()
  },
  methods:{
    sceneParkCoupon(){
      let params = {
        "scene":this.$route.query.scene,
        "url": "/parking/rstParkCoupon/sceneParkCoupon"
      }
      freeCall(params).then(res=>{
        console.log(res)
        if(res.res.code === 10000 && res.body && res.body.data){
          this.showPage = true;
          this.size = res.body.data.size;
          this.parkCouponHeader = res.body.data.parkCouponHeader || {}
        }else{
          util.showToast(res.res.msg)
        }
      })
    },
    //点击立即领取
    getBtnClick(){
      if(!util.isLicensePlate(this.licenseNumber.join(""))){
        util.showToast('请输入正确的车牌号')
        return;
      }
      util.showLoading()
      let params = {
        scene:this.$route.query.scene,
        plateNo:this.licenseNumber.join(""),
        openId: this.common.openId,
        url: "/parking/rstParkCoupon/receiveCoupon"
      }
      freeCall(params).then(res=>{
        util.hideLoading()
        console.log(res)
        if(res.res.code === 10000){
          util.showToast("领取成功~")
          // 领取成功后跳转我的停车券页面,设置对应的停车场id缓存,定位到特定的停车场
          setTimeout(()=>{
            storage.set("prkHeaderId",this.parkCouponHeader.prkHeaderId)
            this.$router.replace(`/parkingService?tab=2`)
          },1000)
        }
      })
    },
    inputchange(value) {
      let arr = this.licenseNumber;
      if (arr.length > 0) {
        this.numClick = 1;
      } else {
        this.numClick = 2;
      }
      if (arr.length > 5) {
        this.textClick = 1;
      } else {
        this.textClick = 2;
      }

      if (arr.length === 8 && value !== 'delete') {
        return;
      }
      // 切换键盘
      if (this.keyBoardType === 1) {
        if (value === 'delete') {
          this.hideModal();
        } else {
          this.keyBoardType = 2;
          arr.push(value);
        }
      } else {
        if (value === 'delete') {
          arr.splice(-1, 1);
          if (arr.length === 0) {
            this.keyBoardType = 1;
          }
        } else {
          arr.push(value);
        }
      }
    },
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.coupon_box{
  margin-top:40px;
}
.card_box {
    margin-top: 48px;
    .title_box{
      position:relative;
    }
    .title {
        font-size: 40px;
        color: rgba(51,51,51,1);
        line-height: 56px;
        text-align: center;
        font-weight: bold;
    }
    .code_change{
      position: absolute;
      top:0;right:40px;
      width:140px;
      height:56px;
      background:rgba(244,244,244,1);
      border-radius:8px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items:center;
      span{
        font-size:28px;
        color:rgba(23,64,218,1);
        margin-left:8px;
      }
      img{
        width:32px;
        height:32px;
      }
    }
}
// 车牌号
.cardBox {
    .flex();
    justify-content: center;
    margin: 60px 0;
    background: #fff;
    position:relative;
    .card_item {
        width: 72px;
        height: 84px;
        line-height: 84px;
        border-radius: 4px;
        // .border_2px(rgba(224,224,224,1));
        border: 2px solid rgba(224,224,224,1);
        text-align: center;
        margin: 0 5px;
        position: relative;
        font-size: 40px;
        // font-weight: bold;
        &:last-child {
            background: rgba(243,251,249,1);
            .border_2px(rgba(198,238,225,1));
        }
        img {
            display: block;
            width: 80px;
            height: 30px;
            position: absolute;
            top: -18px;
            left: 50%;
            transform: translate(-50%);
        }
    }
    .curS {
        .border_2px(rgba(23,64,218,1));
        &:last-child {
            .border_2px(rgba(23,64,218,1));
        }
    }
    .curS_2 {
        .border_2px(#333333);
    }
  .cardbox_item{
    width:112px;
    height:112px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing:border-box;
    border-bottom:4px solid #999;
    margin:0 20px;
    position:relative;
    font-size:60px;
    // font-weight:bold;
    color:rgba(23,64,218,1);
  }
  .line{
    &:after{
      content:'';
      position:absolute;
      width:4px;
      height:60px;
      background:rgba(23,64,218,1);
      top:50%;
      left:50%;
      transform: translate(-50%,-50%);
    }
  }
  .card_input{
    position: absolute;
    top:0;left:0;bottom:0;
    width:100%;
    z-index:2;
    opacity: 0;
  }
}
.btn_box {
    margin: 0 40px 60px;
    .search_btn {
        height: 80px;
        line-height: 80px;
        text-align: center;
        color: #fff;
        background: @color17;
        border-radius: 8px;
        font-size: 32px;
        box-shadow: 0 8px 16px 0 rgba(195,202,229,1);
    }
    .search_btn_2 {
        box-shadow: 0 8px 16px 0 rgba(243,235,203,1);
    }
}
</style>
